export function includesCaseInsenstive(value, searchTerm) {
  return (value || '').toLowerCase().includes((searchTerm || '').toLowerCase());
}
